






































































































import { Component, Vue,Prop, Model, Watch  } from "vue-property-decorator";
import YcColorPicker from "@/components/color-picker/index.js";
import Pop from './components/pop.vue'
import EmbeddedPopup from './components/embeddedPopup.vue'
import Text from './components/text.vue'
import {FormWheelOfFortuneSettingsVO, FormWheelSliceVO, PopSettingsVO, TFormSaveDetailRequest} from "@/model/FormWheel";
import {
  getCountryPhoneCodeCodeList
} from "@/services/api";
import EventBus from '@/utils/eventBus';

@Component({
  components: {
    "yc-color-picker": YcColorPicker,
    "pop-exhibition": Pop,
    "text-exhibition": Text,
    "embedded-popup": EmbeddedPopup
  }
})
export default class wheelOfFortunePop extends Vue {

  @Prop(Array)
  pageSettings!:any

  @Prop(Number)
  triggerEventType!:any

  @Prop(String)
  activePageSetting!:string;

  @Prop(Object)
  formData!:TFormSaveDetailRequest<PopSettingsVO>;

  device = 'desktop'
  countryList = []
  subscribeStatus = 'success'

  get enableSubscribeDifferentPage() {
    return this.formData.successPageType === 1;
  }

  async created(): Promise<void> {
    this.getPhoneCodeCodeList()
    
    // 监听清空订阅状态的事件
    EventBus.$on('clear-subscribe-status', () => {
      this.subscribeStatus = 'success';
    });
  }

  async getPhoneCodeCodeList(){
    let {data ,status }  = await getCountryPhoneCodeCodeList({},true)
    if (status == 200) {
      this.countryList = data.data
    }
  }

  changeActivePageSetting(val:string, opacity: number){
    if(opacity != 1){
      return
    }
    this.$emit('changeActivePageSetting',val)
  }

  changeText(e:any){
    this.$emit('changeformData',e)
  }

  nextStep(){
    this.$emit('nextStep')
  }

  backStep() {
    this.$emit('backStep')
  }

  cancel(){
    this.$emit('cancel')
  }

  changeSubscribeStatus() {
    // 订阅状态切换时的处理逻辑
    // subscribeStatus 值会自动更新，通过 prop 传递给 embedded-popup
  }

  @Watch('formData.settings.rules.terminalType')
  terminalTypeChange(val:string){
    if (this.formData.settings.rules.terminalType === 'mobile') {
      this.device = 'phone'
    }else if (this.formData.settings.rules.terminalType === 'pc') {
      this.device = 'desktop'
    }else{
      this.device = 'desktop'
    }
  }


}
